<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WYAbKQ/tc-custom/9781429925280.jpg?1737745985094" alt="This image is the cover for the book The Sword-Edged Blonde, The Eddie LaCrosse Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Sword-Edged Blonde, The Eddie LaCrosse Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>It should have been a case like any other: a missing princess, a king willing to pay in gold for her return. But before he realizes it, sword jockey Eddie LaCrosse is swept up in a web of mystery and deceit involving a brutally murdered royal heir, a queen accused of an unspeakable crime, and the tragic past he thought he'd left behind.<br/><br/>In order to uncover the answers he seeks, Eddie must delve into the dark underbelly of society while digging deep into his own private history, drawing past and present together. Vast conspiracies, women both beautiful and deadly, and a centuries-old revenge scheme are only a few of the pieces in a lethal puzzle.<br/><br/><i>The Sword-Edged Blonde</i> is a tour-de-force foray into a realm of action, intrigue, and murder.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Bledsoe
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c786b2a